import { IconButtonProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import Icon from "~widgets/icon"
import styled from '~/ui/styled'

const Wrap = styled.TouchableOpacity`
  padding: 4px;
`

const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  color,
  iconName = "jh",
  size = 28,
}) => {
  const theme = useTheme()
  return (
    <Wrap onClick={onClick}>
      <Icon name={iconName} size={size} color={color || theme.colors.primary} />
    </Wrap>
  )
}

export default IconButton
